import { Store } from 'vuex'
import Component from 'vue-class-component'
import RootState from '../../store/state'
import PreviewContainerVue from './PreviewContainer'
import { IContainerData } from '../../store/editor/components/state'
import HeaderSectionVue from './HeaderSection.vue'
import initializePreviewFactory from './PreviewVueFactoryInitializer'

@Component({
  components: {
    'header-section': HeaderSectionVue
  }
})
export default class ArticleVue extends PreviewContainerVue<IContainerData> {
  $store: Store<RootState>

  created(): void {
    initializePreviewFactory()
  }
}
